module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', [_vm._v("Agendamentos ainda não realizados deste paciente")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Situação")]), _vm._v(" "), _c('th', [_vm._v("Unidade realizadora")]), _vm._v(" "), _c('th', [_vm._v("Data da realização")]), _vm._v(" "), _c('th', [_vm._v("Prof. Realizador")]), _vm._v(" "), _c('th', [_vm._v("Procedimento")]), _vm._v(" "), _c('th', [_vm._v("Solicitado em")]), _vm._v(" "), _c('th', [_vm._v("Unidade solicitante")]), _vm._v(" "), _c('th', [_vm._v("Prof. Solicitante")]), _vm._v(" "), _c('th', [_vm._v("Prof. Marcador")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.$props.naoRealizados), function(item, index) {
    return _c('tr', {
      key: index,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_c('strong', {
      class: _vm._f("situacaoSolicitacaoColor")(item.solicitacao.situacao)
    }, [_vm._v("\n                                    " + _vm._s(_vm._f("situacaoSolicitacao")(item.solicitacao.situacao)) + "\n                                ")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.contrato_procedimento_atendimento ? item.contrato_procedimento_atendimento.contrato_procedimento.contrato.unidade.nome : item.contrato_subgrupo_atendimento.contrato_subgrupo.contrato.unidade.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(item.contrato_procedimento_atendimento ? item.contrato_procedimento_atendimento.data_atendimento : item.contrato_subgrupo_atendimento.data_atendimento)) + " às " + _vm._s(item.contrato_procedimento_atendimento ? item.contrato_procedimento_atendimento.hora_inicial : item.contrato_subgrupo_atendimento.hora_inicial))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.contrato_procedimento_atendimento ? item.contrato_procedimento_atendimento.profissional.nome : "SEM PROFISSIONAL"))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.contrato_procedimento.procedimento.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(item.solicitacao.created_at)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.contrato_procedimento.contrato.unidade.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.solicitacao.profissional.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.solicitacao.usuario.name))])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    class: {
      'pull-left': !_vm.$props.regulacao,
      'pull-right': _vm.$props.regulacao
    },
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" Fechar")]), _vm._v(" "), (!_vm.$props.regulacao) ? _c('button', {
    ref: "selecionarProfissional",
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": function($event) {
        _vm.$emit('selecionarProfissional')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-right"
  }), _vm._v(" Selecionar profissional")]) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-788a43d9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atendimentos/comuns/modalNaoRealizados.vue
// module id = 871
// module chunks = 0